/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetAssistantSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetAssistantRequest = {
  /**
   * The assistant ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetAssistantSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAssistantSecurity$outboundSchema: z.ZodMiniType<
  GetAssistantSecurity$Outbound,
  GetAssistantSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getAssistantSecurityToJSON(
  getAssistantSecurity: GetAssistantSecurity,
): string {
  return JSON.stringify(
    GetAssistantSecurity$outboundSchema.parse(getAssistantSecurity),
  );
}

/** @internal */
export type GetAssistantRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetAssistantRequest$outboundSchema: z.ZodMiniType<
  GetAssistantRequest$Outbound,
  GetAssistantRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getAssistantRequestToJSON(
  getAssistantRequest: GetAssistantRequest,
): string {
  return JSON.stringify(
    GetAssistantRequest$outboundSchema.parse(getAssistantRequest),
  );
}
